import { render, staticRenderFns } from "./Tank2D.vue?vue&type=template&id=250bd956"
import script from "./Tank2D.vue?vue&type=script&lang=js"
export * from "./Tank2D.vue?vue&type=script&lang=js"
import style0 from "./Tank2D.vue?vue&type=style&index=0&id=250bd956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports